import type { JSX } from "react";

import { Button, Svg } from "@impero-com/ui";
import { Card } from "antd";

import LogoBodil from "../../img/logo-bodil.svg";
import Logo from "../../img/logo.svg";
import { IMPERO_HELPDESK_URL } from "../../utils/help";
import { t } from "../../utils/i18n";

import * as theme from "./theme.css";

const FormCardContainer = (props: FormCardContainerProps) => {
    const { children, rightSide, fullWidth, showLogo, inline } = props;

    const formPageFooter = (
        <footer className={theme.formPageFooter}>
            <Svg
                src={LogoBodil}
                className={theme.formPageFooterSvg}
                style={{ width: "30px", height: "30px" }}
            />
            <p className={theme.textFooter}>{t("Footer")}</p>
            <Button variant="link" block asChild>
                <a
                    id="support-button"
                    href={IMPERO_HELPDESK_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    {t("LoginFlow_Support")}
                </a>
            </Button>
        </footer>
    );

    const cardContent = (
        <div className={theme.cardContent}>
            {showLogo && (
                <div className={theme.cardLogo}>
                    <Svg
                        src={Logo}
                        style={{ width: "220px", height: "33px" }}
                    />
                </div>
            )}
            <Card bordered={false} className={theme.loginFormCard}>
                <div className={theme.loginCardWrapper}>{children}</div>
            </Card>
        </div>
    );

    if (inline) {
        return <div className={theme.inlineWrapper}>{cardContent}</div>;
    }

    return (
        <div
            className={
                fullWidth ? theme.formWrapperFullWidth : theme.formWrapper
            }
        >
            {fullWidth ? (
                <div className={theme.loginFormLeftFullWidth}>
                    {cardContent}
                </div>
            ) : (
                <div className={theme.loginFormLeft}>
                    {cardContent}
                    {formPageFooter}
                </div>
            )}

            {rightSide ? rightSide : null}
        </div>
    );
};

interface FormCardContainerProps {
    children?: any;
    rightSide?: JSX.Element;
    fullWidth?: boolean;
    showLogo?: boolean;
    inline?: boolean;
}

export default FormCardContainer;
